import { rosterAPI } from '@/providers/apis/roster/roster';
import { USERS_FILTERS } from '@/utils/roster';
import { Vue, Component, Prop } from 'vue-property-decorator';
import { sessionService } from '@/providers/services/auth/session';
import { PERMISSION_CHECK } from '@/utils/constants';
import { adminUtilsAPI } from '@/providers/apis/admin-utils/admin-utils';
import { isAPICatchError, isEmptyValue, passwordValidation, sortByProperty } from '@/utils/utils';
import { groupsApi } from '@/providers/apis/groups/groups';
import { copy } from '@/utils/cohort';
import AclSelect from '@/components/acl-select/acl-select';
import SlidePopupLayout from '@/components/cards/slide-popup-layout/slide-popup-layout';
import moment from 'moment';
import DateRangePicker from 'vue2-daterange-picker';
import PasswordValidate from '@/components/password-validate/password-validate';
import { Value } from 'sass';

@Component({
    name: 'users-page',
    components: {
        'slide-pullup': SlidePopupLayout,
        'acl-select': AclSelect,
        'date-range-picker': DateRangePicker,
        'password-validate': PasswordValidate,
    },
})

export default class UsersPage extends Vue {

    public get parenData() {
        return this.classData ? this.classData : this.schoolData;
    }

    public get isDefaultPassword() {
        return sessionService.getTenantDefaultPassword();
    }

    public get isPermissionToAdd() {
        return sessionService.isAdminORSuperAdmin() ? true : false;
    }

    // -----------------------------------------------------------------------
    // Properties

    public fieldsItems: any[] = [
        {
            key: 'index',
            label: 'S.No',
            thClass: 'sticky-position',
            tdClass: 'align-baseline',
            allowFilter: false,
        },
        {
            key: 'lastName',
            label: 'Last Name',
            thClass: 'sticky-position',
            sortable: true,
            tdClass: 'align-baseline',
            allowFilter: true,
        },
        {
            key: 'firstName',
            label: 'First Name',
            thClass: 'sticky-position',
            sortable: true,
            tdClass: 'align-baseline',
            allowFilter: true,
        },
        {
            key: 'rosterGlobalUserid',
            label: 'Code',
            thClass: 'sticky-position',
            sortable: true,
            tdClass: 'align-baseline',
            allowFilter: true,
        },
        {
            key: 'displayName',
            label: 'Username',
            thClass: 'sticky-position',
            sortable: true,
            tdClass: 'align-baseline',
            allowFilter: true,
        },
        {
            key: 'email',
            label: 'Email',
            thClass: 'sticky-position',
            sortable: true,
            tdClass: 'align-baseline',
            allowFilter: true,
        },
        {
            key: 'loginType',
            label: 'Login Type',
            thClass: 'sticky-position',
            sortable: true,
            tdClass: 'align-baseline',
            allowFilter: false,
        },
        {
            key: 'updatedAt',
            label: 'Last Updated Date',
            thClass: 'sticky-position',
            sortable: true,
            tdClass: 'align-baseline',
            allowFilter: true,
        },
        {
            key: 'action',
            label: 'Action',
            thClass: 'sticky-position action-button',
            tdClass: 'action-button',
            sortable: true,
            allowFilter: false,
        },
    ];

    public dateRange: any = {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: new Date(),
    };

    public searchItem: any = {};

    public isShowDateFilter: boolean = false;

    public isSubmitted: boolean = false;

    public showPasswordstatus: boolean = false;

    public usersList: any = [];

    public perPage: number = 10;

    public totalRowCounts: number = 10;

    public currentPage: number = 1;

    public isLoading: boolean = false;

    public activeUserType: { name: string, key: string } | any = USERS_FILTERS[1];

    public userTypes: Array<{ name: string, key: string }> = USERS_FILTERS;

    public limit: number = 10;

    public offset: number = 0;

    public searchTerms: any = {};

    public selectedUser: any = {};

    public isShowPullup: boolean = false;

    public activePullup = 'user-class-table';

    public propBind: any = {};

    public removeFromHierarchy: any = ['class'];

    public userDetailsForm: any = {
        username: {
            name: 'User Name',
            field: 'b-form-input',
            modelKey: 'username',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        displayName: {
            name: 'Display name',
            field: 'b-form-input',
            modelKey: 'displayName',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        firstName: {
            name: 'First name',
            field: 'b-form-input',
            modelKey: 'firstName',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        lastName: {
            name: 'Last name',
            field: 'b-form-input',
            modelKey: 'lastName',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        email: {
            name: 'Email',
            field: 'b-form-input',
            modelKey: 'email',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        udise: {
            name: 'School UDISE / NCSE Ids',
            field: 'b-form-input',
            modelKey: 'udise',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
    };

    public cohortLevel: any = [];

    public addUser: any = {};

    @Prop({ default: null })
    public schoolData: any;

    @Prop({ default: null })
    public classData: any;

    public passwordUpdated: any = '';

    public selectionALCs: any = {};

    public selectionALCsList: any = {};

    public selectedTeacher: any = {};

    public isAclSelectionGrid: any = true;

    public isSearched: any = false;

    public editData: any = {};

    public editUser: any = {username: '', email: ''};

    public isEdited: boolean = false;

    public userEditDetailsForm: any = {
        firstName: {
            name: 'First Name',
            field: 'b-form-input',
            modelKey: 'firstName',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        lastName: {
            name: 'Last Name',
            field: 'b-form-input',
            modelKey: 'lastName',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        displayName: {
            name: 'Display name',
            field: 'b-form-input',
            modelKey: 'displayName',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        username: {
            name: 'User Name',
            field: 'b-form-input',
            modelKey: 'username',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        email: {
            name: 'Email',
            field: 'b-form-input',
            modelKey: 'email',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
        role: {
            name: 'Role',
            field: 'b-form-select',
            modelKey: 'role',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
            propBind: {
                options: [
                    {
                        text: 'Teachers',
                        value: 'teacher',
                    },
                    {
                        text: 'Students',
                        value: 'student',
                    },
                    {
                        text: 'Others',
                        value: 'other',
                    },
                ],
            },
        },
        referenceId: {
            name: 'Reference Id',
            field: 'b-form-input',
            modelKey: 'referenceId',
            modelValue: '',
            validate: { required: true },
            eventBind: {},
        },
    };
    public parentDetail: any = null;
    public errorMsg = '';
    // -----------------------------------------------------------------------
    // Actions

    public onSelectPage(pageNumber: number) {
        this.usersList = [];
        this.currentPage = pageNumber;
        this.offset = (pageNumber - 1) * this.limit;
        this.getUsersList();
    }

    public onSearch() {
        this.resetProperties();
        this.getUsersList();
    }

    public onEdit(row: any) {
        const item = row.item || {};

        // Assign user details safely
        const fields = ['username', 'email', 'role', 'referenceId', 'firstName', 'lastName', 'displayName'];
        fields.forEach((field) => {
            this.editUser[field] = item[field] || '';
        });

        this.editData = row;
        // Check if selected user has groupSchoolId to show/hide ACL selection grid
        this.isAclSelectionGrid = true;

        const groupSchoolId = parseInt(item.groupSchoolId, 10);
        const level = this.cohortLevel;
        const parentObject = level[level.length - 1];

        if (parentObject && parentObject.child) {
            for (const key of Object.keys(parentObject.child)) {
                const childData = parentObject.child[key].cohortList.find((list: any) => list.id === groupSchoolId);
                if (childData) {
                    this.parentDetail = childData;
                    break;
                }
            }
        }

        let schoolList;
        let clusterList;
        let blockList;
        let districtList;
        let stateList;
        let countryList;
        if (this.parentDetail && this.parentDetail.parentId && level[5] && level[5].child
            && level[5].child[this.parentDetail.parentId]) {
            schoolList = level[5].child[this.parentDetail.parentId].cohortList
                .find((cohort: any) => cohort.id === this.parentDetail.id);

            if (schoolList && schoolList.parentId) {
                clusterList = findParent(level[4], schoolList.parentId);
                if (clusterList && clusterList.parentId) {
                    blockList = findParent(level[3], clusterList.parentId);
                    if (blockList && blockList.parentId) {
                        districtList = findParent(level[2], blockList.parentId);
                        if (districtList && districtList.parentId) {
                            stateList = findParent(level[1], districtList.parentId);
                            if (stateList && stateList.parentId) {
                                countryList = findParent(level[0], stateList.parentId);
                            }
                        }
                    }
                }
            }
        }

        if (countryList) {
            this.onSelectListItem(null, countryList.id, 0);
        }
        if (stateList) {
            this.onSelectListItem(null, stateList.id, 1);
        }
        if (districtList) {
            this.onSelectListItem(null, districtList.id, 2);
        }
        if (blockList) {
            this.onSelectListItem(null, blockList.id, 3);
        }
        if (clusterList) {
            this.onSelectListItem(null, clusterList.id, 4);
        }
        if (schoolList) {
            this.onSelectListItem(null, schoolList.id, 5);
        }

        if (this.editUser) {
            this.onChangeInput();
        }

        this.$bvModal.show('edit-user');

        function findParent(levelObj: any, parentId: any) {
            for (const key of Object.keys(levelObj.child || {})) {
                const match = levelObj.child[key].cohortList
                    .find((cohort: any) => cohort.id === parseInt(parentId, 10));
                if (match) {
                    return match;
                }
            }
            return null;
        }
    }

    public onChangeInput() {
        if (this.editUser.username !== this.editData.item.username ||
            this.editUser.email !== this.editData.item.email ||
            this.editUser.role !== this.editData.item.role ||
            this.editUser.referenceId !== this.editData.item.referenceId ||
            this.editUser.firstName !== this.editData.item.firstName ||
            this.editUser.lastName !== this.editData.item.lastName ||
            this.editUser.displayName !== this.editData.item.displayName
        ) {
            this.isEdited = true;
        } else {
            this.isEdited = false;
        }
    }

    public onGoBack() {
        const classData = this.classData;
        const schoolData = this.schoolData;
        const prevLocation = classData ? 'classData' : 'schoolData';
        this.$router.push(this.parenData.routePath);
        this.$emit('onSelectRow', null, prevLocation);
    }

    public onSwitchUserType(selectedType: { name: string, key: string }) {
        this.activeUserType = selectedType;
        this.resetProperties();
        this.getUsersList();
    }

    public onSelectUser(userDetail?: any) {
        this.isShowPullup = true;
        this.activePullup = 'user-class-table';
        this.propBind = {
            selectedRow: userDetail,
        };
    }

    public onClose() {
        this.isShowPullup = false;
    }

    // -----------------------------------------------------------------------
    // Hooks

    public created() {
        const parenData = this.parenData;
        if (parenData && parenData.columnData) {
            this.activeUserType = this.userTypes.find((item) => item.key === parenData.columnData);
            this.isAclSelectionGrid = false;
        }
        if (!this.resetPasswordPermissionCheck()) {
            const filedIndex = this.fieldsItems.findIndex((item: any) => item.key === 'action');
            if (filedIndex !== -1) {
                this.fieldsItems.splice(filedIndex, 1);
            }
        }
        if (this.isAclSelectionGrid) {
            this.fetchUserACL();
        }

        this.addUser.role = this.activeUserType.key === 'teacher' ? 'teacher' : 'student';
        this.getUsersList();
    }


    // ------------------------------------------------------------------------
    // Methods

    public getUsersList() {
        this.isLoading = true;
        const offset = this.offset;
        const limit = this.limit;
        const searchTerms = this.searchTerms;
        const role = this.activeUserType.key;
        const parentData = this.parenData;
        const params: any = {
            offset,
            limit,
            role,
        };
        for (const key in searchTerms) {
            if (Object.prototype.hasOwnProperty.call(searchTerms, key)) {
                const element = searchTerms[key];
                if (!isEmptyValue(element)) {
                    params[key] = element;
                }
            }
        }

        // If type not getting from parentData it should be class type
        if (parentData) {
            params.parent_id = parentData.id;
            params.type = parentData.type || 'class';
        }
        rosterAPI.getUsersDetails(params).then((data) => {
            this.usersList = [];
            this.isLoading = false;
            if (!isAPICatchError(data)) {
                this.usersList = data.users;
                this.totalRowCounts = data.totalCounts;
            }
        });
    }

    public resetProperties() {
        this.usersList = [];
        this.limit = 10;
        this.offset = 0;
        this.currentPage = 1;
    }

    public onSelectComponent(component: any, selectedTeacher: any) {
        if (component === 'user-class-table') {
            this.onSelectUser(selectedTeacher);
        } else {
            this.isShowPullup = true;
            this.activePullup = component;
            this.propBind.selectedTeacher = selectedTeacher;
        }

    }

    public showPasswordPopup(item: any) {
        this.selectedUser = {};
        this.passwordUpdated = '';
        this.$set(this, 'showPasswordstatus', false);
        if (item.loginType === 'credential') {
            this.selectedUser = item;
            this.$bvModal.show('reset-password');
        }
    }

    public onResetPassword() {
        const params = {
            user_id: this.selectedUser.id,
            password: this.passwordUpdated,
        };
        if (!passwordValidation(this.passwordUpdated)) {
            return;
        }
        adminUtilsAPI.resetPassword(params).then((data: any) => {
            if (!isAPICatchError(data)) {
                this.hideModal();
            }
        });
    }

    public hideModal() {
        this.$bvModal.hide('reset-password');
    }

    public resetPasswordPermissionCheck() {
        let isCheck = false;
        if (sessionService.isSuperAdminUser() || this.$access.isHavingPermisson(PERMISSION_CHECK.resetPassword)) {
            isCheck = true;
        }
        return isCheck;
    }

    public showAddUserPopup() {
        for (const iterator of this.cohortLevel) {
            this.selectionALCs[iterator.sequence] = '';
        }
        this.addUser = {};
        this.addUser.role = this.activeUserType.key === 'teacher' ? 'teacher' : 'student';
        this.isSubmitted = false;
        this.$bvModal.show('add-user');
    }

    public hideUserModal() {
        this.$bvModal.hide('add-user');
    }

    public inputValidator(errors: any, keyName: string) {
        return this.isSubmitted && errors.has(keyName);
    }

    public createUser() {
        this.isSubmitted = true;
        const session: any = sessionService.getSession();
        if (session && session.group_school_id) {
            this.addUser.groupSchoolId = session.group_school_id;
        } else {
            if (this.isAclSelectionGrid) {
                const coho = this.cohortLevel[this.cohortLevel.length - 1];
                if (coho.type === 'school') {
                    this.addUser.groupSchoolId = this.selectionALCs[coho.sequence];
                }
            } else {
                this.addUser.groupSchoolId = this.parenData.id;
            }
        }
        this.$validator.validate().then((valid) => {
            if (valid) {
                const userData = {
                    username: this.addUser.username,
                    display_name: this.addUser.displayName,
                    first_name: this.addUser.firstName,
                    last_name: this.addUser.lastName,
                    email: this.addUser.email,
                    group_school_id: this.addUser.groupSchoolId,
                    user_category: this.activeUserType.key === 'teacher' ? 'teacher' : 'student',
                    tenant_id: session.tenant!.tenant_id,
                    info: null,
                    is_deleted: false,
                    is_account_verified: true,
                    enable_force_password_change: false,
                    login_type: 'credential',
                    is_email_verified: true,
                    roster_global_userid: this.addUser.udise,
                };
                const payload: any = {
                    users: [userData],
                };
                adminUtilsAPI.addUser(payload).then((data: any) => {
                    if (!isAPICatchError(data)) {
                        this.hideUserModal();
                        this.getUsersList();
                    }
                });
            }
        });
    }

    public fetchUserACL() {
        groupsApi.fetchUserHierarchies().then((hierarchy: any) => {
            for (const iterator of this.removeFromHierarchy) {
                hierarchy[0].levels = hierarchy[0].levels.filter((item: any) => {
                    return item.type !== iterator;
                });
            }
            sortByProperty(hierarchy[0].levels, 'sequence', 'ASC');
            this.cohortLevel = hierarchy[0].levels;
            this.fetchCohortListAll();
        });
    }

    public async fetchCohortListAll() {
        this.isLoading = true;
        const levels: any = copy(this.cohortLevel);
        for await (const [index, iterator] of levels.entries()) {
            iterator.child = {};
            iterator.child = await groupsApi.fetchGroupedHierarchyMapping({ type: iterator.type });
            this.selectionALCs[iterator.sequence] = '';
            if (iterator.sequence === 1) {
                this.selectionALCsList[iterator.sequence] = iterator.child[0].cohortList;
                this.selectionALCs[iterator.sequence] = 0;
            }
            if (index === levels.length - 1) {
                this.isLoading = false;
                this.cohortLevel = levels;
            }
        }
    }

    public onSelectListItem(type: any, selectedId: any, index: any) {
        const selected = this.cohortLevel[index + 1];
        this.$set(this.selectionALCs, this.cohortLevel[index].sequence, selectedId);
        if (selected && selected.sequence) {
            if (selected.child[selectedId]) {
                this.$set(this.selectionALCsList, selected.sequence, selected.child[selectedId].cohortList);
            } else {
                this.$set(this.selectionALCsList, selected.sequence, []);
            }
        }
        if (this.selectionALCsList ) {
            this.isEdited = true;
        } else {
            this.isEdited = false;
        }
    }

    public applyDefault() {
        this.passwordUpdated = this.isDefaultPassword;
    }

    public showDateFilter() {
        this.isShowDateFilter = true;
        setTimeout(() => {
            const datePick: any = this.$refs.picker as HTMLElement;
            if (datePick) {
                datePick[0].togglePicker(true);
            }
        }, 200);
    }

    public updateValues() {
        this.offset = 0;
        const dataRange = copy(this.dateRange);
        this.searchTerms.modified_at = `${moment(dataRange.startDate).format('YYYY-MM-DD')}`;
        this.onSearch();
    }

    public removeDateFilter() {
        this.isShowDateFilter = false;
        this.dateRange = {
            startDate: moment().format('YYYY-MM-DD'),
            endDate: new Date(),
        };
        this.searchTerms.modified_at = '';
        this.onSearch();
    }

    public dateFormat(classes: any, date: any) {
        if (!classes.disabled) {
            const a = moment(date.getTime()).format('DD MMM YYYY');
            const b = new Date();
            classes.disabled = moment(a).isAfter(b);
        }
        return classes;
    }

    public searchTable(searchText: any, searchKey: any) {
        if (searchText.length >= 3 || isEmptyValue(searchText)) {
            switch (searchKey) {
                case 'firstName':
                    this.searchTerms.search_first_name = searchText;
                    break;
                case 'lastName':
                    this.searchTerms.search_last_name = searchText;
                    break;
                case 'displayName':
                    this.searchTerms.search_display_name = searchText;
                    break;
                case 'search_group_sourced_id':
                    this.searchTerms.search_group_sourced_id = searchText;
                    break;
                case 'rosterGlobalUserid':
                    this.searchTerms.search_roster_global_user_id = searchText;
                    break;
                case 'email':
                    this.searchTerms.search_email = searchText;
                    break;
                case 'username':
                    this.searchTerms.search_username = searchText;
                default:
                    break;
            }
            const that = this;
            if (!that.isSearched) {
                that.isSearched = true;
                setTimeout(() => {
                    that.isSearched = false;
                    that.onSearch();
                }, 1000);
            }
        }
    }

    public removeDate(searchText: any, searchKey: any) {
        switch (searchKey) {
            case 'firstName':
                this.searchTerms.search_first_name = '';
                this.searchItem.firstName = '';
                break;
            case 'lastName':
                this.searchTerms.search_last_name = '';
                this.searchItem.lastName = '';
                break;
            case 'displayName':
                this.searchTerms.search_display_name = '';
                this.searchItem.displayName = '';
                break;
            case 'search_group_sourced_id':
                this.searchTerms.search_group_sourced_id = '';
                this.searchItem.search_group_sourced_id = '';
                break;
            case 'rosterGlobalUserid':
                this.searchTerms.search_roster_global_user_id = '';
                this.searchItem.rosterGlobalUserid = '';
                break;
            case 'email':
                this.searchTerms.search_email = '';
                this.searchItem.email = '';
                break;
            case 'username':
                this.searchTerms.search_username = '';
                this.searchItem.username = '';
            default:
                break;
        }
        this.onSearch();
    }

    public updatingPw(text: any) {
        this.passwordUpdated = text;
    }
    public hideEditUserModal() {
        this.$bvModal.hide('edit-user');
        this.editUser.username = '';
        this.editUser.email = '';
        this.editUser.role = '';
        this.editUser.referenceId = '';
        this.editUser.firstName = '';
        this.editUser.lastName = '';
        this.editUser.displayName = '';
        this.errorMsg = '';
    }

    public saveUser() {
        this.isLoading = true;
        this.isSubmitted = true;
        this.$validator.validate().then((valid) => {
            if (valid) {
                if (!this.editUser.username || !this.editUser.email || !this.editUser.role ||
                    !this.editUser.referenceId || !this.editUser.firstName ||
                    !this.editUser.lastName || !this.editUser.displayName) {
                    this.isLoading = false;
                    return;
                }
                const params: any = {
                    user_id: this.editData.item.id,
                };
                const parentId = this.selectionALCs[
                    Object.keys(this.selectionALCs)[Object.keys(this.selectionALCs).length - 1]
                ];
                if (parentId) {
                    params.group_school_id = parentId;
                }
                if (this.editUser.email !== this.editData.item.email) {
                    params.email = this.editUser.email;
                }
                if (this.editUser.username !== this.editData.item.username) {
                    params.username = this.editUser.username;
                }
                if (this.editUser.role !== this.editData.item.role) {
                    params.user_category = this.editUser.role;
                }
                if (this.editUser.referenceId !== this.editData.item.referenceId) {
                    params.reference_id = this.editUser.referenceId;
                }
                if (this.editUser.firstName !== this.editData.item.firstName) {
                    params.first_name = this.editUser.firstName;
                }
                if (this.editUser.lastName !== this.editData.item.lastName) {
                    params.last_name = this.editUser.lastName;
                }
                if (this.editUser.displayName !== this.editData.item.displayName) {
                    params.display_name = this.editUser.displayName;
                }

                adminUtilsAPI.updateUser(params).then((data) => {
                    this.isLoading = false;
                    if (data.statusCode === 400) {
                        this.errorMsg = data.message;
                    } else {
                        if (!isAPICatchError(data)) {
                            this.hideEditUserModal();
                            this.getUsersList();
                            this.fetchCohortListAll();
                        }
                    }
                });
            } else {
                this.isLoading = false;
            }
        });
    }
}
